<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api_crm.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte';
    import TopInfo from '../components/TopInfo.svelte';  
    import Preloader from '../components/Preloader.svelte'; 
    import { updateUrlParam } from '../base/url.js';
    import { dndzone } from 'svelte-dnd-action';



    let isLoading = false;



    export let params = {};

    let object_id = params.object_id;
    let object = {};
    let fields = [];

    
    onMount(fetch);

    async function fetch() {

        //console.log('UserStore',$UserStore)

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }
      
        isLoading = true;        

        let postData = {
            action : 'index',
            object : params.object_id,
            settings : 1
        }

        let results = await fetchData(postData);

        fields = results.fields;
        object = results.object;

        isLoading = false;


        
        
    }

    $: if (params.object_id !== object_id) {
        object_id = params.object_id;
        fetch();
    }


    function handleDnd({ detail }) {

        fields = detail.items; // Update the field order after drag and drop
        // After reordering, update the sort field to reflect the new position
        fields.forEach((field, index) => {
            field.sort = index + 1;
        });
    }

    const saveFields = async() => {

        isLoading = true;        

        let postData = {
            action : 'index',
            object : params.object_id,
            fields ,
            name : object.name,
            save_fields : 1
        }

        await fetchData(postData);
        isLoading = false;
        fetch();
    }

       

    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">

        <TopInfo />   
        
        <div class="dash-list"> 
            <div class="flex text-black bg-[--dash-bg-gray-color] mb-[10px]">
                <div class="flex-item flex-1 py-[4px] px-[10px] hover:bg-[--dash-primary-color] hover:text-white">{$_('object_settings.fields')}</div>
                <div class="flex-item flex-1 py-[4px] px-[10px] hover:bg-[--dash-primary-color] hover:text-white">{$_('object_settings.automation')}</div>
                <div class="flex-item flex-1 py-[4px] px-[10px] hover:bg-[--dash-primary-color] hover:text-white">{$_('object_settings.connections')}</div>
                <div class="flex-item flex-1 py-[4px] px-[10px] hover:bg-[--dash-primary-color] hover:text-white">{$_('object_settings.actions')}</div>
            </div>
            <h1><input type="text" bind:value={object.name}></h1>
            <div class="table">
                <div class="head">                   
                    <div>{$_('object_settings.id')}</div>
                    <div>{$_('object_settings.sort')}</div>
                    <div>{$_('object_settings.name')}</div>
                    <div>{$_('object_settings.code')}</div>
                    <div>{$_('object_settings.required')}</div>
                    <div>{$_('object_settings.hidden')}</div>
                    <div>{$_('object_settings.type')}</div>
                    <div>{$_('object_settings.prefix')}</div>
                    <div>{$_('object_settings.postfix')}</div>
                </div>
                {#each fields as field}
                    <div>
                        <div>{field.id}</div>
                        <div><input type="text" bind:value={field.sort} class="w-[100px]"></div>
                        <div><input type="text" bind:value={field.name}></div>
                        <div>{field.code}</div>
                        <div>
                            <select bind:value={field.is_required}>
                                <option value={1}>{$_('object_settings.required')}</option>
                                <option value={0}>{$_('object_settings.not_required')}</option>
                            </select>
                        </div>
                        <div>
                            <select bind:value={field.hidden}>
                                <option value={1}>{$_('object_settings.hidden')}</option>
                                <option value={0}>{$_('object_settings.visible')}</option>
                            </select>
                        </div>
                        <div>
                            <select bind:value={field.type}>
                                <option value="text">{$_('object_settings.text')}</option>
                                <option value="number">{$_('object_settings.number')}</option>
                                <option value="date">{$_('object_settings.date')}</option>
                                <option value="boolean">{$_('object_settings.boolean')}</option>
                            </select>
                        </div>

                        <div><input type="text" bind:value={field.prefix}></div>
                        <div><input type="text" bind:value={field.postfix}></div>
                    </div>
                {/each}

            </div> 
            <div on:click={ ()=> { saveFields(); } } class="button bg-[--dash-primary-color] fixed w-[100px] bottom-[10px] left-0 right-0 m-auto p-[10px]">
                {$_('settings.save')}
            </div>
        </div>
    </div>
</div>